import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getBranch } from './get-branch';

/** `DELETE /client/:cid/branches/:id/three-pl`. */
export const deletBranchThreePl = async (branch_id: string): Promise<any> => {
  await lpRequest('DELETE', clientPath(`/branches/${branch_id}/three-pl`));

  return getBranch(branch_id);
};
